export const REGISTER_REQUEST = "LOGIN_REQUEST";
export const REGISTER_SUCCESS = "LOGIN_SUCCESS";
export const REGISTER_FAILURE = "LOGIN_FAILURE";